module.exports = __webpack_public_path__ + "static/media/featureIcon3.d236211b.png";